// extracted by mini-css-extract-plugin
export default {"form":"Login_form__-xGaQ","buttons":"Login_buttons__prA+O","errors":"Login_errors__Qcl9D","row":"Login_row__1WGCJ"};